const REQUESTS_URL_PREFIX = "requests";
const DEFAULT_REQUEST_FAILED_MESSAGE = "Request failed";

export { REQUESTS_URL_PREFIX, DEFAULT_REQUEST_FAILED_MESSAGE };
